import { limit, type PlanKey } from "@giftforward/entitlements";
import { useCampaignBuilder } from "@/context/CampaignBuilderContext";
import { useMyEntitlements } from "@/hooks/useMyEntitlements";

/** The caller's own per-campaign recipient cap and plan; both null while unlimited or not loaded. */
export function useRecipientCap(): { cap: number | null; planKey: PlanKey | null } {
  const { ent } = useMyEntitlements();
  if (!ent) return { cap: null, planKey: null };
  return { cap: limit(ent, "campaign_send", "max_recipients"), planKey: ent.plan.key };
}

/** Opens the builder's "Contact limit reached" modal, whose primary action opens the plan modal. */
export function useOpenRecipientCapBlocked(): () => void {
  const { openModal, openPlanModal } = useCampaignBuilder();
  return () =>
    openModal({
      context: "recipientCapBlocked",
      onPrimary: () => openPlanModal("recipientCapBlocked"),
    });
}
